import { useEffect } from 'react';
import { setSubProduct } from '@atlassian/jira-platform-router-utils/src/common/utils/index.tsx';
import { useSubProductForAnalytics } from '@atlassian/jira-subproduct/src/index.tsx';

const SubProductForAnalyticsUpdater = () => {
	const subProduct = useSubProductForAnalytics();
	useEffect(() => {
		setSubProduct(subProduct);
	}, [subProduct]);

	return null;
};

export { SubProductForAnalyticsUpdater };
